export enum ERROR_PAGE_DATA{
  PATH='/Not Found Page',
  TITLE='Not Found Page',
  TEMPLATE='ErrorPageTemplate'
 }